// workApi.js
import axiosInstance from "./mainApi";
import store from "../store/store"; // Redux store importálása
import {
  addWork,
  loadWorks,
  deleteWork,
  updateWork
} from "../store/actions/workStoreFunctions";
import { useDispatch } from "react-redux";
import {
  receiveCreatedItemsForWork,
  receiveCreatedTablesForWork
} from "../store/actions/objectStoreFunctions";
const isFrontendOnly = (x) => x?.frontend === true;

const getAllWorksApi = async () => {
  try {
    const response = await axiosInstance.get("/works");
    console.log("Loading works from server response: ", response);

    const data = Array.isArray(response.data) ? response.data : [];

    if (response.status === 200) {
      store.dispatch(loadWorks(data)); // Dispatching to update Redux store
    }
    return data;
  } catch (error) {
    console.error("Error fetching works:", error);
    throw error;
  }
};

export const saveWorkWithRelatedApi = (workId, partialWork) => {
  return async (dispatch) => {
    const { data } = await axiosInstance.put(
      `/works/${workId}/save-with-related`,
      partialWork
    );

    const work = data?.work;
    const items = (data?.items || []).filter((it) => !isFrontendOnly(it));
    const tables = (data?.tables || []).filter((t) => !isFrontendOnly(t));
    if (work) dispatch(updateWork(work));
    const wid = work?.workId ?? workId;
    console.log("Disptaching created items and tables for workId:", wid);
    console.log("Items:", items);
    console.log("Tables:", tables);
    dispatch(receiveCreatedItemsForWork(wid, items));
    dispatch(receiveCreatedTablesForWork(wid, tables));

    return data;
  };
};

export const updateScheduleDateApi = (workId, { iso, epochMs } = {}) => {
  return async (dispatch) => {
    try {
      const params = {};
      if (iso) params.iso = iso; // pl. "2025-09-12T10:00:00Z" vagy "2025-09-12"
      if (epochMs != null) params.epochMs = epochMs; // pl. 1736745600000

      const { data } = await axiosInstance.put(
        `/works/${workId}/schedule-date`,
        null,
        { params }
      );

      dispatch(updateWork(data));
      return data;
    } catch (error) {
      console.error("Error while updating schedule date:", error);
      throw error;
    }
  };
};

// --- ÚJ: munka megrendelése / rendelés státusz állítása ---
// ordered=true -> megrendelés; ordered=false -> visszavonás (ha kell)
// refreshRelated=true esetén azonnal lehívja a save-with-related-et és frissíti az items/tables store-t
export const setWorkOrderedApi = (
  workId,
  ordered = true,
  { refreshRelated = false } = {}
) => {
  return async (dispatch) => {
    try {
      const { data } = await axiosInstance.post(
        `/works/${workId}/order`,
        null,
        { params: { ordered } }
      );

      dispatch(updateWork(data));

      if (refreshRelated) {
        // Üres táblák törlése a szerveren már megtörtént; frissítsük a kliens store-t is
        const bundle = await dispatch(saveWorkWithRelatedApi(workId, {}));
        return { work: data, bundle };
      }

      return data;
    } catch (error) {
      console.error("Error while setting work ordered flag:", error);
      throw error;
    }
  };
};

// Delete a work
const deleteWorkApi = (workId) => {
  return async (dispatch) => {
    try {
      console.log(workId);
      await axiosInstance.delete(`/works/${workId}`);
      console.log("Work deleted successfully.");
      dispatch(deleteWork(workId));
    } catch (error) {
      console.error("Error while deleting work:", error);
      throw error;
    }
  };
};

////////////////////
// Updating section
export const updateWorkApi = (workId, updatedWorkData) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.put(
        `/works/${workId}`,
        updatedWorkData
      );
      dispatch(updateWork(response.data));
    } catch (error) {
      console.error("Error while updating work:", error);
      throw error;
    }
  };
};

const createWorkApi = (workData) => {
  return async (dispatch) => {
    try {
      console.log("creating new work");
      const response = await axiosInstance.post(`/works`, workData);
      console.log("Work added successfully:", response);

      dispatch(addWork(response.data));
      return response.data;
    } catch (error) {
      console.error("Error while adding work:", error);
      throw error;
    }
  };
};

const getWorkOfUserAdminApi = (workId) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(`/works/${workId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching works:", error);
      throw error;
    }
  };
};

export default {
  preprocessWorkApi: async (workId) => {
    const { data } = await axiosInstance.post(`/works/${workId}/preprocess`);
    if (!Array.isArray(data)) throw new Error("INVALID_PREPROCESS_RESPONSE");
    return data;
  },
  getAllWorksApi,
  deleteWorkApi,
  updateWorkApi,
  createWorkApi,
  getWorkOfUserAdminApi
};
